/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageDeliveryError { 
    attempt_date_time?: Date;
    attempt_number?: number;
    csp_request_id?: string;
    csp_status_code?: string;
    reason?: string;
}

